import { IFolderItem } from '@cxstudio/common/folders/folder-item.interface';

export class FolderUtils {
	static readonly MAX_DEPTH: number = 5;

	static isFolder(item: {type?: string}): item is IFolderItem {
		return item && /.*folder.*/i.test(item.type);
	}
}
